export default  {
    DEPLOY: "deploy",
    INTERACT: "interact",
    //More specific
    EXECUTE: "execute",//deploys or mutable functions
    CALL: "call"//dry runs or view functions
};
